import n, { forwardRef as O } from "react";
import { cls as c } from "../../../helpers/cls.js";
var w = Object.defineProperty,
  l = Object.getOwnPropertySymbols,
  s = Object.prototype.hasOwnProperty,
  i = Object.prototype.propertyIsEnumerable,
  f = (e, a, r) => a in e ? w(e, a, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[a] = r,
  p = (e, a) => {
    for (var r in a || (a = {})) s.call(a, r) && f(e, r, a[r]);
    if (l) for (var r of l(a)) i.call(a, r) && f(e, r, a[r]);
    return e;
  },
  m = (e, a) => {
    var r = {};
    for (var t in e) s.call(e, t) && a.indexOf(t) < 0 && (r[t] = e[t]);
    if (e != null && l) for (var t of l(e)) a.indexOf(t) < 0 && i.call(e, t) && (r[t] = e[t]);
    return r;
  };
const v = O((e, a) => {
  var r = e,
    {
      children: t,
      className: u,
      viewportProps: d
    } = r,
    b = m(r, ["children", "className", "viewportProps"]);
  const o = d || {},
    {
      className: y
    } = o,
    N = m(o, ["className"]);
  return n.createElement("div", p({
    className: c("olx-carousel__viewport", y),
    ref: a
  }, N), n.createElement("div", p({
    className: c("olx-carousel__content", u)
  }, b), t));
});
v.displayName = "CarouselContent";
export { v as CarouselContent };